// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as Webapi__Dom__Element from "../../../../node_modules/rescript-webapi/lib/es6_global/src/Webapi/Dom/Webapi__Dom__Element.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as DynamicTruncate$Showside from "./DynamicTruncate.bs.js";
function AudioCard(Props) {
  var contentUrl = Props.contentUrl;
  var thumbnailUrl = Props.thumbnailUrl;
  var name = Props.name;
  var match = React.useState(function () {
    return false;
  });
  var setIsPlaying = match[1];
  var isPlaying = match[0];
  var playerRef = React.useRef(null);
  React.useEffect(function () {
    var el = playerRef.current;
    if (!(el == null)) {
      el.addEventListener("play", function ($$event) {
        Curry._1(setIsPlaying, function (param) {
          return true;
        });
      });
      el.addEventListener("ended", function ($$event) {
        Curry._1(setIsPlaying, function (param) {
          return false;
        });
      });
      el.addEventListener("pause", function ($$event) {
        Curry._1(setIsPlaying, function (param) {
          return false;
        });
      });
      return function (param) {
        el.removeEventListener("play", function ($$event) {
          Curry._1(setIsPlaying, function (param) {
            return true;
          });
        });
        el.removeEventListener("ended", function ($$event) {
          Curry._1(setIsPlaying, function (param) {
            return false;
          });
        });
        el.removeEventListener("pause", function ($$event) {
          Curry._1(setIsPlaying, function (param) {
            return false;
          });
        });
      };
    }
  }, [playerRef.current]);
  var togglePlay = function (param) {
    var el = playerRef.current;
    if (!(el == null)) {
      if (isPlaying) {
        el.pause();
        return;
      } else {
        Belt_Array.forEach(Belt_Array.keepMap(Belt_Array.map(Array.prototype.slice.call(document.documentElement.querySelectorAll("audio")), Webapi__Dom__Element.ofNode), function (a) {
          return a;
        }), function (prim) {
          prim.pause();
        });
        el.play();
        return;
      }
    }
  };
  return React.createElement("div", {
    className: CSS$Showside.prefix("cursor-pointer group"),
    style: {
      width: "100px"
    },
    onClick: togglePlay
  }, React.createElement("div", {
    className: CSS$Showside.prefix("relative mb-3")
  }, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["w-full relative overflow-hidden flex-grow-0", "aspect-ratio-square", "rounded-full"]))
  }, React.createElement("div", {
    className: CSS$Showside.prefix("absolute w-full h-full")
  }, React.createElement(SmartImg$Showside.make, {
    src: thumbnailUrl,
    fit: /* Cover */1,
    alt: name,
    priority: 0
  }), React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute inset-0 bg-black bg-opacity-50 transition-opacity duration-300", isPlaying ? "opacity-100" : "opacity-0 group-hover:opacity-100"]))
  }, isPlaying ? React.createElement(Unicons$Showside.UilPause.make, {
    className: CSS$Showside.prefix("transform absolute left-1/2 top-1/2 transform -translate-y-1/2 -translate-x-1/2 text-white")
  }) : React.createElement(Unicons$Showside.UilPlay.make, {
    className: CSS$Showside.prefix("transform absolute left-1/2 top-1/2 transform -translate-y-1/2 -translate-x-1/2 text-white")
  }))), React.createElement("div", {
    className: CSS$Showside.prefix("opacity-0")
  }, React.createElement("audio", {
    ref: ReactDOMUtils$Showside.Ref.domRef(playerRef),
    src: contentUrl
  })))), React.createElement("div", {
    className: CSS$Showside.prefix("flex-grow-1 leading-normal relative text-lg text-center text-secondary")
  }, React.createElement(DynamicTruncate$Showside.make, {
    lines: 2,
    lineHeight: 21,
    children: name
  })));
}
AudioCard.displayName = "AudioCard";
var make = AudioCard;
export { make };
/* react Not a pure module */